<template>
<div id="contents">
  <div id="tapcast" class="page_contents">
    <div class="page_header">
      <h1 class="page_header_title">
        <img src="../assets/img/tapcast/title.png" width="352" alt="TAP CAST" />
        <span>キャスティング・マネジメント</span>
      </h1><!-- .top_sec_title -->
    </div><!-- .page_header -->

    <div id="tapcast_contents">
      <div id="important_notice">
        <h2 class="title">大切なお知らせ</h2>
        <div class="message">
          <p>平素より、弊社が展開してまいりましたキャスティング・マネジメント事業「TAP CAST」<br />（旧クリエイターエージェンシー）にご支援いただき、誠にありがとうございます。</p>
          <p>この度、2011年4月よりご提供してまいりました「TAP CAST」事業を、<br />2024年3月末日をもちまして終了する運びとなりましたことをお知らせいたします。</p>
          <p>この終了は、弊社の都合によるものです。<br />関係各位には、ご迷惑をおかけいたしますこと、深くお詫びを申し上げます。<br />永年にわたりご利用いただきましたお客様、所属してくださったキャストの皆様には、<br />心より感謝を申し上げます。</p>
          <p>「TAP CAST」終了後も、弊社とキャストの皆様との繋がりは途絶えることはありません。<br />以下に、各キャストの4月以降の連絡先をご案内いたします。</p>
        </div>
        <ul class="cast_list">
          <li>
            <ul class="left">
              <li>
                <p class="name">ローランド</p>
                <p class="link"><a href="https://arch.tv-asahipro.co.jp/cast/154/" target="_blank" rel="noopener">https://arch.tv-asahipro.co.jp/cast/154/</a></p>
              </li>
              <li>
                <p class="name">Mr.マリック</p>
                <p class="link"><a href="/works/magic/" target="_blank" rel="noopener">https://tv-asahipro.co.jp/works/magic/</a></p>
              </li>
              <li>
                <p class="name">ロバート キャンベル</p>
                <p class="ttl">株式会社ある日のこと</p>
                <p class="email"><a href="mailto:aruhinokoto@icloud.com">aruhinokoto@icloud.com</a></p>
                <p class="contact_person"><a href="tel:08044051849">080-4405-1849</a>　担当：石井 理</p>
              </li>
              <li>
                <p class="name">YOURI</p>
                <p class="link"><a href="/works/magic/" target="_blank" rel="noopener">https://tv-asahipro.co.jp/works/magic/</a></p>
              </li>
            </ul>
          </li>
          <li>
            <ul class="right">
              <li>
                <p class="name">三志郎</p>
                <p class="link"><a href="/works/magic/" target="_blank" rel="noopener">https://tv-asahipro.co.jp/works/magic/</a></p>
              </li>
              <li>
                <p class="name">谷口 亮</p>
                <p class="email"><a href="mailto:fute@ryos-w.com">fute@ryos-w.com</a></p>
                <p class="tel"><a href="tel:09071647629">090-7164-7629</a></p>
              </li>
              <li>
                <p class="name">鈴木 淳也</p>
                <p class="link"><a href="https://law-sj.com/contact/media" target="_blank" rel="noopener">https://law-sj.com/contact/media</a></p>
              </li>
              <li>
                <p class="name">ゆーこ</p>
                <p class="link"><a href="https://unidango.ocnk.net/" target="_blank" rel="noopener">https://unidango.ocnk.net/</a></p>
              </li>
              <li>
                <p class="name">TAKUYA</p>
                <p class="link"><a href="/works/magic/" target="_blank" rel="noopener">https://tv-asahipro.co.jp/works/magic/</a></p>
              </li>
            </ul>
          </li>
        </ul>
        <div class="message after">
          <p>今後とも、キャストに対する変わらぬご支援を賜りますようお願い申し上げます。<br />また、キャストの皆様の益々のご活躍を祈念いたします。</p>
          <p>何卒ご理解とご協力を賜りますよう、お願い申し上げます。</p>
        </div>
      </div>
    </div><!-- #tapcast_contents -->

  </div><!-- #tapcast -->

</div><!-- #contents -->
</template>

<script>
import tapcastContact from './shared/tapcastContact.vue'
export default {
  name: 'players_index',
  data() {
    return {
      api_url: this.$parent.api_base_url+'/api/tapcast/index.php',
      api_category_url: this.$parent.api_base_url+'/api/tapcast/fetch_category.php',
      category_box: false,
      loading: false,
      cast: null,
      biz_collab_cast: [],
      categories: null,
      select_category: 0,
      select_category_name: 'ジャンル別に見る',
      error: null
    }
  },
  computed: {
    main_cast: function(){
      if(this.cast){
        return this.cast.slice(0, 2)
      }
    },
    sub_cast: function(){
      if(this.cast){
        return this.cast.slice(2)
      }
    }
  },
  components: {
    tapcastContact
  },
  methods: {
    fetch_cast_list(){
      this.$axios
        .get(this.api_url)
        .then(response => {
          this.cast = response.data.item
          for (let i = 0; i < this.cast.length; i++) {
            if (["biz_collab"].includes(this.cast[i].affiliation)) {
              this.biz_collab_cast = this.biz_collab_cast.concat(this.cast[i])
              this.cast.splice(i--, 1);
            }
          }
          if(this.biz_collab_cast == false){
            this.biz_collab_cast = null
          }
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
        .finally(() => this.$emit('page_fade'))
    },
    show_category_box(){
      if(!this.category_box){
        this.category_box = true
      }
    },
    slect_category(event){
      const term_id = event.target.getAttribute('data')
      const name = event.target.getAttribute('name')
      this.select_category = term_id
      this.select_category_name = name
      this.fetch_player_list()
      this.category_box = false
      event.preventDefault()
    },
    fetch_category_list(){
      this.$axios
        .get(this.api_category_url)
        .then(response => {
          this.categories = response.data.categories
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
        .finally(() => this.loading = false)
    }
  },
  mounted () {
    this.fetch_category_list()
    this.fetch_cast_list()
  },
  updated (){
  }
}
</script>

<style scoped lang="sass">
</style>



// WEBPACK FOOTER //
// src/components/tapcast_index.vue